import type { ReactNode } from 'react';
import { ChevronRightIcon, XIcon, EuroIcon, CheckIcon, SparkleIcon, DownloadIcon } from '@/components/icons.tsx';
import { ActionRow } from './ActionRow.tsx';
import styles from './SystemActions.module.css';

export type SystemActionVariant = 'red' | 'amber' | 'green' | 'blue';

export interface SystemAction {
  id: string;
  variant: SystemActionVariant;
  label: string;
  description: string;
  onTrigger: () => void;
  disabled?: boolean;
  /** Overrides the default icon for this action's variant. */
  icon?: ReactNode;
}

function ActionIcon({ variant }: { variant: SystemActionVariant }) {
  if (variant === 'red') return <XIcon size={14} />;
  if (variant === 'amber') return <EuroIcon size={14} />;
  if (variant === 'blue') return <DownloadIcon size={14} />;
  return <CheckIcon size={14} />;
}

const badgeClass: Record<SystemActionVariant, string> = {
  red: styles.iconBadgeRed,
  amber: styles.iconBadgeAmber,
  green: styles.iconBadgeGreen,
  blue: styles.iconBadgeBlue,
};

interface SystemActionsProps {
  actions: SystemAction[];
}

export function SystemActions({ actions }: SystemActionsProps) {
  return (
    <div className={styles.section}>
      <div className={styles.sectionHeader}>
        <span className={`${styles.sectionIconBadge} ${styles.sectionIconBadgeRed}`}><SparkleIcon size={12} /></span>
        <span className={styles.sectionLabel}>Acties</span>
      </div>
      <div className={styles.actionsList}>
        {actions.map((action) => (
          <ActionRow
            key={action.id}
            label={action.label}
            description={action.description}
            iconLeft={<span className={`${styles.iconBadge} ${badgeClass[action.variant]}`}>{action.icon ?? <ActionIcon variant={action.variant} />}</span>}
            iconRight={<ChevronRightIcon size={11} className={styles.arrow} />}
            onClick={action.onTrigger}
            disabled={action.disabled}
          />
        ))}
      </div>
    </div>
  );
}
